import { render, staticRenderFns } from "./ButtonShowModalGenerateBalance.vue?vue&type=template&id=4f996016&scoped=true&"
import script from "./ButtonShowModalGenerateBalance.vue?vue&type=script&lang=js&"
export * from "./ButtonShowModalGenerateBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f996016",
  null
  
)

export default component.exports